import { en } from "./en";
import { ar } from "./ar";

const localization = {
  en,
  ar,
};

export default localization;
